import { defineStore } from 'pinia';

export const useLoginStore = defineStore('login', {
  state: () => ({
    showLoginModal: false,
    redirectAfterLogin: null,
  }),
  actions: {
    openLoginModal(redirectRoute = null) {
      this.showLoginModal = true;
      this.redirectAfterLogin = redirectRoute;
    },
    closeLoginModal() {
      this.showLoginModal = false;
      this.redirectAfterLogin = null;
    },
  },
});
